var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shouldDisplayCell
    ? _c("div", { staticClass: "completeness-detail-modal-table-cell" }, [
        _c(
          "div",
          {
            staticClass: "completeness-detail-modal-table-cell__legend",
            style: _vm.colorStyle,
          },
          [
            _c(
              "div",
              {
                class: [
                  "completeness-detail-modal-table-cell__legend__tooltip",
                  "completeness-detail-modal-table-cell__legend__tooltip--" +
                    _vm.positioning,
                ],
              },
              _vm._l(_vm.tooltipLines, function (line, index) {
                return _c(
                  "span",
                  {
                    key: index,
                    class: {
                      "completeness-detail-modal-table-cell__legend__tooltip__text--first":
                        index === 0,
                    },
                  },
                  [_vm._v(" " + _vm._s(line) + " ")]
                )
              }),
              0
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }